import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";

@Component({
    selector: 'app-component-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;

    constructor(
        private router: Router,
        private titleService: Title,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Contact");
    }

    ngOnInit() { }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }
}